export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Памылка ініцыялізацыі",
    "StaticConfigLoader.caption.init": "Ініцыялізацыя",
    "StaticConfigLoader.text.init": "Ініцыялізацыя прыкладання...",
    "StaticConfigLoader.error.settings": "Немагчыма загрузіць налады прыкладання",
    "StaticConfigLoader.error.circuits": "Немагчыма загрузіць канфігурацыю контураў",
    //app
    "Legal.Localization": "be",
    "AchievementApp.Navbar.storeTitle": "Store",
    "AchievementApp.Navbar.supportTitle": "Support",
    "Legal.TermsConditions": "Terms and Conditions",
    "Legal.TermsService": "Terms of Service",
    "Legal.PrivacyPolicy": "Privacy Policy",
    "Legal.CookiesPolicy": "Налады файлаў cookie",
    "Legal.Copyright": "All trademarks, logos and brand names are the property of their respective owners.",
    "AchievementApp.Navbar.achievement": "Асабістыя дасягненні",
    "AchievementApp.Navbar.userAchievement": "Дасягненні карыстальніка",
    "AchievementApp.Navbar.settingsLink": "Налады",
    "AchievementApp.Navbar.profileLink": "Профіль",
    "AchievementApp.Navbar.reloginLink": "Увайсці зноў або змяніць уліковы запіс",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net Дасягненні",
    //commonAssets
    "ViewItemDetailed.state.completed": "Завершана",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Фільтр па гульнях",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Мае сябры",
    "UserFriendsList.heading.showMore": "Паказаць больш",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Неабходна наладзіць двухфактарную аўтарызацыю",
    "LimitedAccountPanel.2step.link": "Больш пра двухфактарную аўтарызацыю",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Неабходна пацвердзіць адрас электроннай пошты",
    "LimitedAccountPanel.email.link": "Перайсці да профілю",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Ваш уліковы запіс абмежаваны з-за:",
    "LimitedAccountPanel.conclusion": "Пасля змены налад бяспекі Вам трэба выйсці з уліковага запісу і ўвайсці зноў, каб змены пачалі дзейнічаць",
    "LimitedAccountPanel.relogin": "Увайсці зноў",
    "EmailVerificationStateIcon.success": "Пацверджаны ўліковы запіс, адрас электроннай пошты пацверджаны",
    "EmailVerificationStateIcon.warning": "Абмежаваны ўліковы запіс, адрас электроннай пошты не пацверджаны",
    "EmailVerificationStateIcon.danger": "Абмежаваны ўліковы запіс, ПАТРАБУЕЦЦА пацвердзіць адрас электроннай пошты",
    "TwoFactorStateIcon.success": "Уліковы запіс абаронены двухфактарнай аўтарызацыяй",
    "TwoFactorStateIcon.warning": "Абмежаваны ўліковы запіс, двухфактарная аўтарызацыя адключана",
    "TwoFactorStateIcon.danger": "ПАТРАБУЕЦЦА двухфактарная аўтарызацыя",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Захаваць налады",
    "UserSettingDialog.settings": "Налады",
    "UserSettingDialog.userSettings": "Налады карыстальніка",
    "UserSettingDialog.language": "Мова",
    "UserSettingDialog.privacy": "Прыватнасць",
    "UserSettingDialog.allUsers": "Усе карыстальнікі",
    "UserSettingDialog.friendsOnly": "Толькі сябры",
    "UserSettingDialog.onlyMe": "Толькі я",
    "UserSettingDialog.whoCanView": "Хто можа бачыць мае дасягненні",
    //unlockProgress
    "ViewUnlockProgress.of": " з ",
    "ViewUnlockProgress.achievCompleted": " дасягненняў выканана",
    "ViewUnlockProgress.myUnlock": "Мае дасягненні",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Увесці нікнэйм",
    "ViewItemSearch.label.search": "Пошук карыстальнікаў",
    "ViewItemSearch.resultNotFound": "Карыстальнік не знойдзены",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Дасягненне",
    "ViewItemSearch.stub.empty": "Няма дасягненняў",
    "ViewItemSearch.stub.emptyCompare_1": "Карыстальнік ",
    "ViewItemSearch.stub.emptyCompare_2": " няма дасягненняў у гэтай гульні",
    "ViewItemSearch.limitedAccess": "Доступ да дасягненняў выбранага карыстальніка абмежаваны",
    "ViewItemSearch.heading.selectGame": "Выбраць гульню са спіса",
    "ViewItemSearch.globalstat.opened": "разблакавана ",
    "ViewItemSearch.globalstat.ofGamers": "% гульцоў",
    //authentication
    "NotAllowedMessage.caption": "Забаронена",
    "NotAllowedMessage.body.h1": "Доступ да Дасягненняў",
    "NotAllowedMessage.body.h3": "для Вашага ўліковага запісу забаронены",
    "NotAllowedMessage.relogin": "Змяніць уліковы запіс",
    "LandingMessage.caption": "Аўтэнтыфікацыя",
    "LandingMessage.body": "Завяршэнне праверкі",
    "TokenExpiredMessage.caption": "Тэрмін дзеяння аўтэнтыфікацыі скончыўся",
    "TokenExpiredMessage.body.h3": "Каб працягваць, неабходна аўтарызавацца",
    "TokenExpiredMessage.relogin": "Увайсці зноў",
    "AuthErrorMessage.caption": "Памылка аўтэнтыфікацыі",
    "AuthErrorMessage.body.h1": "Не ўдалося прайсці аўтэнтыфікацыю",
    "AuthErrorMessage.body.code": "Код",
    "AuthErrorMessage.body.desc": "Каб працягваць, неабходна аўтарызавацца",
    "AuthErrorMessage.relogin": "Увайсці зноў",
    "AuthorizationRequiredMessage.caption": "Патрабуецца аўтэнтыфікацыя",
    "AuthorizationRequiredMessage.body.h3.1": "Для ўвахода ва ўліковы запіс",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Патрабуецца аўтарызацыя",
    "AuthorizationRequiredMessage.login": "Увайсці праз Gaijin.Net",
    "CheckingAuthMessage.caption": "Аўтэнтыфікацыя",
    "CheckingAuthMessage.body": "Праверка аўтэнтыфікацыі, калі ласка, пачакайце",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Мабільная версія часова не даступная",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Калі ласка, выкарыстоўвайце камп'ютэрную версію",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Мы просім прабачэння",
}